import React, { useEffect } from 'react'
import { useModalBox, useOnChangeDetect } from '../../../../contexts'
import Button from '../../../button'
import Input from '../../../input'
import Textarea from '../../../textarea'
import { Row } from './style'
import { useForm } from '../../../../hooks'
import { RelevantFactModel } from '../../../../../domain/models/relevant-fact'
import {
  createNewRelevantFact,
  updateRelevantFact
} from '../../../../../main/usecases/services/relevantfact'
import { useAlert } from 'react-alert'
import moment from 'moment'

type FormProps = {
  cdServiceProps: number | undefined
  relevantFact?: RelevantFactModel | undefined
}
export const formatDate = (val: any) => {
  const t = val.split('/')
  console.log(t, `${t[1]}-${t[2]}-${t[0]}`)
  return `${t[1]}-${t[0]}-${t[2]}`
}
const FactForm = ({ cdServiceProps, relevantFact }: FormProps) => {
  moment.locale('pt-br')
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const dateInput = useForm()
  const titleInput = useForm()
  const descriptionInput = useForm()
  const { refresh, setRefresh } = useOnChangeDetect()

  useEffect(() => {
    dateInput.setValue(moment().format('YYYY-MM-DD'))
    if (relevantFact) {
      dateInput.setValue(
        moment(formatDate(relevantFact?.dataFatoRelevante)).format('YYYY-MM-DD')
      )
      titleInput.setValue(relevantFact.titulo)
      descriptionInput.setValue(relevantFact.descricao)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relevantFact, refresh])

  console.log(
    'DATA >>>>>',
    relevantFact?.dataFatoRelevante?.replaceAll('/', '-')
  )

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    try {
      const body: RelevantFactModel = {
        // cdFatoRelevante: null,
        dataFatoRelevante: moment(dateInput?.value).format('DD/MM/YYYY'),
        descricao: descriptionInput?.value,
        titulo: titleInput?.value,
        servico: {
          cdServico: cdServiceProps
        }
      }
      if (relevantFact?.cdFatoRelevante) {
        await updateRelevantFact().post({
          ...body,
          cdFatoRelevante: relevantFact?.cdFatoRelevante
        })
        modalClose()
        alert.show('Fato relevante atualizado com sucesso', {
          type: 'success',
          timeout: 4000
        })
      } else {
        await createNewRelevantFact().post(body)
        modalClose()
        alert.show('Fato relevante criado com sucesso', {
          type: 'success',
          timeout: 4000
        })
      }

      setRefresh((prev: any) => !prev)
    } catch (error) {
      alert.show('Erro ao criar um fato relevante', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  return (
    <form className="validate-report-modal" onSubmit={onSubmit}>
      <div>
        <Row className="d-flex">
          <Input
            labelColor="#4F4F4F"
            label="Data*"
            name="county"
            placeholder="Digite"
            type="date"
            style={{ width: '95%' }}
            required
            {...dateInput}
          />
          <Input
            labelColor="#4F4F4F"
            label="Título*"
            name="county"
            type="title"
            required
            {...titleInput}
          />
        </Row>

        <Row className="d-flex">
          <Textarea
            label="Descrição"
            labelColor="#4F4F4F"
            name="resume"
            placeholder="Text"
            {...descriptionInput}
          />
        </Row>
      </div>
      <Row className="button-container">
        <label className="required-msg">*Campos obrigatórios</label>
        <div className="buttons">
          <button
            className="access-complete-register-button"
            onClick={() => modalClose(true)}
          >
            Cancelar
          </button>
          <Button>
            {relevantFact?.cdFatoRelevante ? 'Atualizar' : 'Criar'}
          </Button>
        </div>
      </Row>
    </form>
  )
}

export default FactForm
